import {ApplicationRef, ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, DestroyRef, inject, OnInit} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {RouterOutlet} from '@angular/router';
import { PushNotificationService } from '../core/services/push-notification.service';
import {SwUpdate} from '@angular/service-worker';
import {concat, filter, first, interval} from 'rxjs';

/** Fréquence de vérification en tâche de fond des nouvelles versions déployées. */
const UPDATE_CHECK_INTERVAL_MS = 60 * 1000;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit{
  private readonly _pushService: PushNotificationService = inject(PushNotificationService);
  private readonly _swUpdate: SwUpdate = inject(SwUpdate);
  private readonly _appRef: ApplicationRef = inject(ApplicationRef);
  private readonly _destroyRef: DestroyRef = inject(DestroyRef);
  title = 'braidsbook-admin';

  constructor() {
    if (this._swUpdate.isEnabled) {
      this._swUpdate.versionUpdates
        .pipe(filter((evt) => evt.type === 'VERSION_READY'))
        .subscribe(() => {
          if (confirm('A new version of the app is available. Reload now?')) {
            window.location.reload();
          }
        });

      // Angular ne vérifie une nouvelle version qu'au démarrage : un onglet
      // laissé ouvert longtemps ne verrait sinon jamais VERSION_READY. On
      // déclenche donc un checkForUpdate() toutes les minutes une fois l'app
      // stable (attendre isStable évite de retarder le premier rendu).
      const appIsStable$ = this._appRef.isStable.pipe(first((isStable) => isStable));
      concat(appIsStable$, interval(UPDATE_CHECK_INTERVAL_MS))
        .pipe(takeUntilDestroyed(this._destroyRef))
        .subscribe(() => this._swUpdate.checkForUpdate());
    }
  }

  ngOnInit(): void{
    this._pushService.subscribeToNotifications();
    this._pushService.listenToMessages();
  }
}
